import ColorPicker from 'components/editor/shared/components/ColorPicker';
import Grid from '@mui/material/Grid';
import { SecondaryMenuItemTitle } from './SecondaryMenuTitles';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { getDocumentColors } from 'components/editor/grid/reduxStore/selectors/documentColorsSelector';
import type { colorParams } from 'components/editor/shared/components/ColorPicker/types';

type ColorPickerSectionProps = {
  currentColor?: string;
  onColorChange: (color: string) => void;
  onClose?: (color: string) => void;
  title?: string;
  onOpen?: () => void;
  useLocalPreview?: boolean;
};

export const ColorPickerWithUndoRedoSection = ({
  currentColor = '#fff',
  onColorChange,
  title,
  onClose,
  onOpen,
  useLocalPreview = false,
}: ColorPickerSectionProps) => {
  const { t } = useTranslation();
  const colorPicketTitle = title || t('editor.side_panel.color');

  const [localColor, setLocalColor] = useState(currentColor);
  const [documentColors, setDocumentColors] = useState<colorParams[] | undefined>(undefined);

  useEffect(() => {
    setLocalColor(currentColor);
  }, [currentColor]);

  const handleOpen = () => {
    setLocalColor(currentColor);
    setDocumentColors(getDocumentColors());
    onOpen?.();
  };

  const handleChange = (color: string) => {
    if (useLocalPreview) {
      setLocalColor(color);
    } else {
      onColorChange(color);
    }
  };

  const handleClose = (color: string) => {
    if (useLocalPreview) {
      onColorChange(color);
      onClose?.(color);
    } else {
      onClose?.(color);
    }
  };

  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <SecondaryMenuItemTitle>{colorPicketTitle}</SecondaryMenuItemTitle>
      <Grid item>
        <ColorPicker
          currentColor={useLocalPreview ? localColor : currentColor}
          handleColorChange={handleChange}
          handleOnClose={handleClose}
          onOpen={handleOpen}
          presetColors={documentColors}
        />
      </Grid>
    </Grid>
  );
};
